import { render } from "./CustomKpiWidgetDataConfig.vue?vue&type=template&id=037e4698&scoped=true"
import script from "./CustomKpiWidgetDataConfig.vue?vue&type=script&lang=ts"
export * from "./CustomKpiWidgetDataConfig.vue?vue&type=script&lang=ts"

import "./CustomKpiWidgetDataConfig.vue?vue&type=style&index=0&id=037e4698&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-037e4698"

export default script